import styles from "@/styles/onboarding.module.scss";

const StepperHOC = stepsArray =>
  function Stepper({ application }) {
    const tick = (
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 12.8L9.42857 16L18 8"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );

    return (
      <div className="w-full bg-white py-7 px-0 md:px-10 mx-auto flex flex-wrap justify-center items-center gap-5 md:gap-0">
        <div className={styles.stepper_wrapper}>
          {stepsArray[0] && (
            <div
              className={`${styles.stepper_item} ${
                application >= 1 ? styles.stepper_item_active : null
              }`}
            >
              <div className={styles.step_counter}>
                {application > 1 ? tick : 1}
              </div>
              <div className={styles.step_name}>{stepsArray[0]}</div>
            </div>
          )}
          {stepsArray[1] && (
            <div
              className={`${styles.stepper_item} ${
                application >= 2
                  ? application === 2.5
                    ? styles.stepper_item_error
                    : styles.stepper_item_active
                  : null
              }`}
            >
              <div className={styles.step_counter}>
                {application > 2 ? (application === 2.5 ? 2 : tick) : 2}
              </div>
              <div className={styles.step_name}>{stepsArray[1]}</div>
            </div>
          )}
          {stepsArray[2] && (
            <div
              className={`${styles.stepper_item} ${
                application >= 3 ? styles.stepper_item_active : null
              }`}
            >
              <div className={styles.step_counter}>
                {application > 3 ? tick : 3}
              </div>
              <div className={styles.step_name}>{stepsArray[2]}</div>
            </div>
          )}
          {stepsArray[3] && (
            <div
              className={`${styles.stepper_item} ${
                application >= 4 ? styles.stepper_item_active : null
              }`}
            >
              <div className={styles.step_counter}>
                {application > 4 ? tick : 4}
              </div>
              <div className={styles.step_name}>{stepsArray[3]}</div>
            </div>
          )}
          {stepsArray[4] && (
            <div
              className={`${styles.stepper_item} ${
                application >= 5 ? styles.stepper_item_active : null
              }`}
            >
              <div className={styles.step_counter}>
                {application > 5 ? tick : 5}
              </div>
              <div className={styles.step_name}>{stepsArray[4]}</div>
            </div>
          )}
        </div>
      </div>
    );
  };

export const StepperCustomerCare = StepperHOC([
  "Welcome",
  "Circumstances",
  "Payment Choices",
]);

export const StepperOnboarding = StepperHOC([
  "Personal Details",
  "Your Offer",
  "Get Started",
]);

export const StepperBudget = StepperHOC([
  "Circumstances",
  "Income",
  "Outgoings",
  "Budget Summary ",
]);
